import {
    Button, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle
} from '@mui/material';
import './popup.css'
import api from '../../../service/api';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useHistory } from "react-router-dom";
import CancelIcon from '@mui/icons-material/Cancel'
import ProgressBar from '../../progress/progressBar';
import popUpMessage from '../../../config/popUpMsg.json';
import LillySource from '../../../config/ProfileDetailsData.json'



const Popup = (props) => {
    const history = useHistory();
    const [value, setValue] = useState('');
    const [submit, setSubmit] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [popUptext, setPopUptext]= useState({comment : '' , success : false})
    const [open, setOpen] = useState(false);
    const [popMsg, setPopMsg] = useState(popUpMessage.newHCP)
    const [disableSubmit, setDisableSubmit] = useState(false);
    let originalValues;

    if (props?.originalValues?.Address != null){
       const convertedAddress = Object.values(props.originalValues.Address);
       originalValues = {
        Address: convertedAddress,
        ...Object.keys(props.originalValues).reduce((acc, key) => {
            if (key !== 'Address') {  // Don't include Address here as it's already processed
                acc[key] = props.originalValues[key];
            }
            return acc;
        }, {})
        };
    }else{
        originalValues = props.originalValues
    }

    /**
     * Handle Popup close
     */
    const handleClose = () => {
               
            props.closePopup();
        
        setErrorFlag(false)
    }

    const onOkClick = () =>{
        history.push('/track-request')
    }

    /**
     * Handle comments Input
     * @param {*} event 
     */
    const handelChange = (event) => {
        setValue(event.target.value)
    }

    function filterEmptyValues(obj) {
        Object.keys(obj).forEach(key => {
          if (obj[key] && obj[key][0] && obj[key][0]['value'] === '') {
            delete obj[key]; 
          }
        });
        return obj;
      }

    /***
     * Zip Value Mapping
     */
    const getZipValue = (zip) => {
        if (zip === undefined) {
            return '';
        }
        let zip4 = zip.Zip4;
        let zip5 = zip.Zip5;
        let editZip = zip.value;
        if (editZip) {
            return editZip;
        }
        else if (!zip4 && !zip5) {
            return zip;
        }
        else if (zip4 === undefined) {
            return zip5[0].value;
        } else if (zip5 === undefined) {
            return zip4[0].value;
        } else {
            return zip5[0].value + '-' + zip4[0].value;
        }
    }

    /**
     * Primary address Logic
     * @param {*} updateDetails 
     * @param {*} detail 
     * @returns return address
     */
    const addPrimaryAddress = (updateDetails, detail) => {
        let value = updateDetails?.entity?.AddAddress && updateDetails?.entity?.AddAddress[0] ? updateDetails?.entity?.AddAddress[0] : undefined;
        let newAddedAddress = updateDetails?.entity?.Address || [];
      
        if (value != undefined && value?.Rank[0]?.value === '1' && detail?.entity?.Address && detail?.entity?.Address?.length > 0) {
            let oldAddress = JSON.parse(JSON.stringify(detail.entity.Address));
            if (newAddedAddress && newAddedAddress.length > 0) {
                oldAddress = oldAddress.filter((address) => {
                    return !newAddedAddress.some((item) => item.SourceAddressId?.[0]?.value === address.SourceAddressId?.[0]?.value);
                });
            }      
            let rankOneOldAddress = oldAddress.filter((value) => {
                let flag = false;
                if (value.Rank && value.Rank.length > 0) {
                    value.Rank.forEach((rankValue) => {
                        flag = flag || (rankValue.value === '1')
                    })
                }
                return flag;
            });
            rankOneOldAddress = (rankOneOldAddress && rankOneOldAddress.length > 0) ? rankOneOldAddress.map((addressValue) => {
                return {
                    ...addressValue,
                    Rank: [{ value: '99' }]
                }
            }) : [];

            newAddedAddress = (newAddedAddress && newAddedAddress.length > 0) ? newAddedAddress.map((addressValue) => {
                return {
                    ...addressValue,
                    Rank: [{ value: '99' }]
                }
            }) : [];
            rankOneOldAddress = rankOneOldAddress.concat(newAddedAddress);
            return updateDetails.entity.AddAddress.concat(rankOneOldAddress);
        }
        return updateDetails.entity.AddAddress.concat(newAddedAddress.length > 0 ? newAddedAddress: [] );
    }

    /**
     * Primary address Logic
     * @param {*} updateDetails 
     * @param {*} detail 
     * @returns return address
     */
    const addPrimaryVendorAddress = (updateDetails, detail) => {
        let value = updateDetails.entity.AddAddress[0];

        if (value.Rank[0].value === '1' && detail.entity.Address && detail.entity.Address.length > 0) {
            let oldAddress = JSON.parse(JSON.stringify(detail.entity.Address));
            let rankOneOldAddress = oldAddress.filter((value) => {
                let flag = false;
                if (value.Rank && value.Rank.length > 0) {
                    value.Rank.forEach((rankValue) => {
                        flag = flag || (rankValue.value === '1')
                    })
                }
                return flag;
            });

            // check if rankOneOldAddress is deactivated in updateDetails
            if (updateDetails.entity.Address && updateDetails.entity.Address.length > 0) {
                rankOneOldAddress = rankOneOldAddress.map((addressValue) => {
                    let updatedAddress = updateDetails.entity.Address.find((item) => item.AddressLine1 && addressValue.AddressLine1 && item.AddressLine1[0].value === addressValue.AddressLine1[0].value);
                    return updatedAddress ? updatedAddress : addressValue;
                })
            }


            rankOneOldAddress = (rankOneOldAddress && rankOneOldAddress.length > 0) ? rankOneOldAddress.map((addressValue) => {
                return {
                    ...addressValue,
                    Rank: [{ value: '99' }]
                }
            }) : [];
            return updateDetails.entity.AddAddress.concat(rankOneOldAddress);
        }
        return updateDetails.entity.AddAddress;
    }


    /**
     * Primary Relation logic
     * @param {*} updateDetails 
     * @param {*} detail 
     * @returns return relation
     */
    const addPrimaryRelation = (updateDetails, detail) => {
        let value = updateDetails.relations[0];
        if (value.Rank && value.Rank[0].value === '1' && detail.relations.length > 0) {
            let oldRelation = JSON.parse(JSON.stringify(detail.relations))
            let rankOneRelation = oldRelation.filter((value) => {
                let flag = false;
                if (value.Rank && value.Rank.length > 0) {
                    value.Rank.forEach((rankValue) => {
                        flag = flag || (rankValue.value === '1')
                    })
                }
                return flag;
            })
            if (rankOneRelation && rankOneRelation.length > 0) {
                rankOneRelation = rankOneRelation.map((rankOneRelationValue) => {
                    let uri = '';
                    let label = '';
                    if (rankOneRelationValue.startObject.objectURI.split('/')[1] !== props.uri) {
                        uri = rankOneRelationValue.startObject.objectURI.split('/')[1];
                        label = rankOneRelationValue.startObject.label;
                    } else {
                        uri = rankOneRelationValue.endObject.objectURI.split('/')[1];
                        label = rankOneRelationValue.endObject.label;
                    }
                    return {
                        ...rankOneRelationValue,
                        Rank: [{ value: '2' }],
                        uri: uri,
                        label: label
                    }
                })

            }

            return updateDetails.relations.concat(rankOneRelation);

        }
        return updateDetails.relations;
    }

    /**
     * Submit DCR
     */
    const submitRequest = () => {
        if (value && value.length > 0) {
            setOpen(true)
            setDisableSubmit(true);            
            let updateDetails = props.updateDetails;
            let detail = props.detail;
            if (updateDetails.relations.length > 0 && detail) {
                updateDetails = {
                    ...updateDetails,
                    relations: addPrimaryRelation(updateDetails, detail)
                }
            }

            if (updateDetails.entity.AddAddress !== undefined && !props.typeHCP) {
                if (updateDetails.entity.Address === undefined) {
                    updateDetails.entity = {
                        ...updateDetails.entity,
                        Address: []
                    }
                }
                let rankOneOldAddress = LillySource.LILLY_MANAGED_SOURCES.includes(props.source) || LillySource.OPEN_DATA_SOURCES.includes(props.source) ?  updateDetails.entity.AddAddress && updateDetails.entity.AddAddress.length > 0 && addPrimaryAddress(updateDetails, detail) :
                updateDetails.entity.AddAddress && updateDetails.entity.AddAddress.length > 0 && addPrimaryVendorAddress(updateDetails, detail);
                updateDetails = {
                    ...updateDetails,
                    entity: {
                        ...updateDetails.entity,
                        Address: rankOneOldAddress
                    }
                }

                delete updateDetails.entity.AddAddress;
            }
            updateDetails.entity.Address !== undefined && !props.typeHCP &&
                updateDetails.entity.Address.forEach((value) => {
                    delete value.editKey;
                    if(!value?.IsNew){
                        value.IsEdited = true;
                        if(value?.IsStatusChanged){
                            delete value.IsEdited
                        }
                    }
                    value.Zip = [{ value: getZipValue(value.Zip && value.Zip[0] ? value.Zip[0] : undefined) }]
                })
            let finalComment = '';
            if (props.addNewHCP !== undefined && updateDetails.relations.length > 0) {
                if (updateDetails.entity.FirstName !== undefined && updateDetails.entity.LastName[0] !== undefined && updateDetails?.entity?.Source[0]?.value !== 'VNDR-VOD') {
                    let HCPName = updateDetails.entity.FirstName[0].value + ' ' + updateDetails.entity.LastName[0].value;
                    finalComment = updateDetails.relations[0].uri !== undefined ? (`${value} || For HCP(${HCPName}), Added relation to HCO (${updateDetails.relations[0].label}) with Reltio Id (${updateDetails.relations[0].uri}) is submitted.`) : value;
                } else {
                    finalComment = value;
                }
            } else {
                finalComment = value;
            }
            if(updateDetails?.entity?.NewSpecialities && props.location != undefined && props.location == 'edit' ){
                if(updateDetails?.entity?.NewSpecialities?.hasOwnProperty('PrimarySpecialty')){                    
                    if(updateDetails?.entity?.NewSpecialities?.PrimarySpecialty[0].value !=''){
                        
                        if(!updateDetails.entity.Specialities.some((item)=> item.isDeleted != undefined && item.isDeleted)){                            
                            let allSpecialities = updateDetails.entity.Specialities.filter((item)=> item.Rank && item.Rank[0].value == '1')
                            allSpecialities.forEach(item => item.Rank[0].value = '99' );
                            updateDetails = {
                                ...updateDetails,
                                entity: {
                                    ...updateDetails.entity,
                                    Specialities: allSpecialities
                                }
                            }                   
                        }
                        else{
                            let allSpecialities = updateDetails.entity.Specialities.filter((item)=>  item.isDeleted != undefined && item.isDeleted)
                            updateDetails = {
                                ...updateDetails,
                                entity: {
                                    ...updateDetails.entity,
                                    Specialities: allSpecialities
                                }
                            }
                        }
                    }else{                        
                        delete updateDetails?.entity?.NewSpecialities?.PrimarySpecialty
                    }                    
                }
                if(updateDetails?.entity?.NewSpecialities?.hasOwnProperty('OtherSpecialty')){
                    if(updateDetails?.entity?.NewSpecialities?.OtherSpecialty[0]?.value != '' && !updateDetails?.entity?.NewSpecialities?.hasOwnProperty('PrimarySpecialty') ){                        
                        let allSpecialities = updateDetails.entity.Specialities.filter((item)=>  item.isDeleted != undefined && item.isDeleted)
                            updateDetails = {
                                ...updateDetails,
                                entity: {
                                    ...updateDetails.entity,
                                    Specialities: allSpecialities
                                }
                            }                   
                        
                    }else if(updateDetails?.entity?.NewSpecialities?.OtherSpecialty[0]?.value == '' && !updateDetails?.entity?.NewSpecialities?.hasOwnProperty('PrimarySpecialty') ){
                        delete updateDetails?.entity?.NewSpecialities?.OtherSpecialty
                        let allSpecialities = updateDetails.entity.Specialities.filter((item)=>  item.isDeleted != undefined && item.isDeleted)
                            updateDetails = {
                                ...updateDetails,
                                entity: {
                                    ...updateDetails.entity,
                                    Specialities: allSpecialities
                                }
                            }
                    }else if (updateDetails?.entity?.NewSpecialities?.OtherSpecialty[0]?.value == '' && updateDetails?.entity?.NewSpecialities?.hasOwnProperty('PrimarySpecialty')){
                        delete updateDetails?.entity?.NewSpecialities?.OtherSpecialty
                     }              
                }          
                if(!updateDetails?.entity?.NewSpecialities?.hasOwnProperty('PrimarySpecialty') && !updateDetails?.entity?.NewSpecialities?.hasOwnProperty('OtherSpecialty') ){
                    delete updateDetails.entity.NewSpecialities
                    let allSpecialities = updateDetails.entity.Specialities.filter((item)=>  item.isDeleted != undefined && item.isDeleted)
                            updateDetails = {
                                ...updateDetails,
                                entity: {
                                    ...updateDetails.entity,
                                    Specialities: allSpecialities
                                }
                            }
                }                 
            }            
            let entityData = filterEmptyValues(updateDetails.entity) 
            let relationData = filterEmptyValues(updateDetails.relations)
            updateDetails.entity = entityData 
            updateDetails.relations = relationData

            const renderHTML = (html) => ({ __html: html });
            api.postUpdate({ ...updateDetails, comments: finalComment },{...originalValues}).then(res => {
                let response = res.data[0]  
                setSubmit(true);
                setPopUptext({comment: popMsg[0].dcrSuccess.description.replace(/{{source}}/g, (LillySource.Success_Message_Source[0][response?.vendor ? response.vendor : response?.Vendor])), success: true, ok: true }) 
                setOpen(false)
                setValue('');              
                setDisableSubmit(false);
            })
            .catch((error)=>{
                setSubmit(true);
                setPopUptext({comment:<div dangerouslySetInnerHTML={renderHTML(popMsg[0].dcrFailure.description)}/>, success: false , ok: true}) 
                setOpen(false)
                setValue('');
                setDisableSubmit(false);
            })

          
        }
        else{
            setErrorFlag(true)
        }
    }

    return (<>

    

        <Dialog
            open={props.open}
            onClose={handleClose}
            aria-labelledby="contentIdbox"
            aria-describedby="contentIdboxdes"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="DialogTxtbox" color='primary' className='fw-bold' >{props.title || ''}</DialogTitle>
            <DialogContent id="contentIdbox">
            {submit ? popUptext.success ? <center><CheckCircleRoundedIcon className='success' /></center> : <center><CancelIcon className='secondary' /></center> :
                    <DialogContentText id="contentIdboxdes">
                        {props.message}
                    </DialogContentText>
             }
                {
                    submit &&
                    <>
                        <h6 id="idboxContent">
                        {popUptext.comment}
                        </h6>
                    </>
                }
                {
                    props.success && !submit &&
                    <TextField
                        value={value}
                        className='w-100'
                        onChange={handelChange}
                        multiline
                        rows={3}
                        variant="outlined"
                        error={errorFlag && value.length === 0}
                        helperText={errorFlag && value.length === 0 ? `Please Enter Value` : ''}                        
                    />
                }
                { open &&
                    <center className='mt-2'><ProgressBar size={0.99 * 50} /> </center>
                }
            </DialogContent>

            <DialogActions sx={{mr: '15px'}} id="dialog-action">
            {  ((props.success && !submit && !props.showConfirmationButton) || (!props.success && props.open && !props.showConfirmationButton )) && 
            <Button onClick={()=>handleClose()} color="error" variant="outlined" autoFocus> Close </Button>}
            {
                    props.success && !submit &&
                    <Button 
                        onClick={()=> submitRequest()} 
                        color="error" 
                        variant="contained" 
                        autoFocus
                        disabled={disableSubmit}
                    
                    >
                        Submit                                </Button>
                }

                { (submit && popUptext.ok ) && 
                <Button onClick={()=>onOkClick()} color="error" variant="contained" autoFocus>
                    Confirm
                </Button>}

                { props.showConfirmationButton && 
                <Button onClick={()=>handleClose()} color="error" variant="outlined" autoFocus>
                    No
                </Button>}

                { props.showConfirmationButton && 
                <Button onClick={()=>props.allowDeactivation()} color="error" variant="contained" autoFocus>
                    Yes
                </Button>}

                
            </DialogActions>
        </Dialog>
        </>
    )
}

export default Popup;